import { AxiosResponse } from 'axios';
import { useQuery, UseQueryResult } from 'react-query';
import { WorkoutRetrieve } from 'types';
import { client } from 'utils/api-client';

function useWorkout(workoutId: string | undefined): UseQueryResult<AxiosResponse<WorkoutRetrieve>> {
  return useQuery(['workouts', workoutId], () => client.get<WorkoutRetrieve>(`workouts/${workoutId}/`), {
    enabled: !!workoutId,
  });
}

export default useWorkout;
